import { EditItem, IEditItem } from "ui/Scripts/source/models/common/editItem";
import { IModifyUser, ModifyUser } from "ui/Scripts/source/models/user/modifyUser";

export interface IUserGroupEditItem extends IEditItem {
    code: string;
    name: string;
    comment: string;
    authorizationLevel: number;
    qrCodeUserGroup: boolean;
    createUser: IModifyUser;
    modifyUser: IModifyUser;
}

export class UserGroupEditItem extends EditItem implements IUserGroupEditItem {
    code: string;
    name: string;
    comment: string;
    authorizationLevel: number;
    qrCodeUserGroup: boolean;
    createUser: ModifyUser;
    modifyUser: ModifyUser;

    constructor();
    constructor(obj: IUserGroupEditItem);
    constructor(obj?: any) {
        super(obj);
        this.code = obj && obj.code || "";
        this.name = obj && obj.name || "";
        this.comment = obj && obj.comment || "";
        this.authorizationLevel = obj && obj.authorizationLevel || 0;
        this.qrCodeUserGroup = obj && obj.qrCodeUserGroup || 0;
        this.createUser = new ModifyUser(obj ? obj.createUser : null);
        this.modifyUser = new ModifyUser(obj ? obj.modifyUser : null);
    }
}